/* eslint-disable */
import _ from 'underscore';
import ko from 'knockout';
import StatusViewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/campaign/changeStatus';
import template from '@bingads-webui-static-legacy/bulk-edit/template/campaign/changeStatus.pug';
import actionLinkTemplate from '@bingads-webui-static-legacy/bulk-edit/template/campaign/actionLink.pug';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import filterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
import gridHelper from '@bingads-webui-static-legacy/shared/view/gridHelper';
import urlUtil from '@bingads-webui-static-legacy/app/router/lib/url';
import state from '@bingads-webui-component-legacy/state/index';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var formatStatus = function (rows) {
  if (rows) {
    _.each(rows, function (item) {
      item.Entity = _.find(item.EntityKey, function (item) {
        return item.Key === 'CampaignName';
      });
      item.data = [];
      item.data.push({
        value: item.Entity && item.Entity.Value ? item.Entity.Value : '',
        isHtml: false
      });
      if (item.Changes && item.Changes.length) {
        item.data.push({
          value: i18n.getString('EntityStatus_' + item.Changes[0].OriginalValue),
          isHtml: false
        });
        item.data.push({
          value: i18n.getString('EntityStatus_' + item.Changes[0].NewValue),
          isHtml: false
        });
      } else {
        item.data.push({
          value: '',
          isHtml: false
        });
        item.data.push({
          value: '',
          isHtml: false
        });
      }
    });
  }
  return rows;
};
var view = BaseView.extend({
  initialize: function (options) {
    BaseView.prototype.initialize.apply(this, arguments);
    this.ko_model = new StatusViewModel(this.model);
    this.template = template;
    this.bulkEditUrl = options.bulkEditUrl;
  },
  render: function () {
    if (!gridHelper.isCrossPageAllSelected(this.grid)) {
      this.ko_model.showPanel = false;
    }
    BaseView.prototype.render.apply(this, arguments);
    if (!gridHelper.isCrossPageAllSelected(this.grid)) {
      this.submitJob();
    }
    return this;
  },
  showErrors: function () {
    if (this.ko_model.showPanel) {
      return BaseView.prototype.showErrors.apply(this, arguments);
    }
    var alertId = 'alert-bulkedit-campaignstatus';
    var message = i18n.getString('BulkEdit_CampaignStatus_PartialSuccess', this.model.get('ErrorRowCount'), this.model.get('TotalRowCount'));
    var actionLink = actionLinkTemplate({
      alertId: alertId,
      href: `${this.bulkEditUrl ? this.bulkEditUrl : ''}bulkeditoperation?cid=` + state.get('customer_id') + '&aid=' + state.get('account_id'),
      text: i18n.getString('BulkEdit_ViewDetails')
    });
    window.App.views.alertCenter.show({
      message: message + ' ' + actionLink,
      dismissible: true,
      level: 'Error'
    }, alertId);
  },
  getIdFilter: function () {
    return filterHelper.getIdFilter(this.grid, 'Campaign');
  },
  getProgressText: function () {
    return i18n.getString('BulkEdit_Campaigns_ProgressText');
  },
  formatPreviewResults: function (results) {
    return formatStatus(results);
  },
  formatErrors: function (errors) {
    return formatStatus(errors);
  }
});
export default view;

